<template>
    <div class="apprentice-simple-card remove-bottom-card-margin">
        <design-2021-apprentice-data-table
            class="files-table"
            v-if="files.length"
            :items="files"
            :fields="fileFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-custom-editor-file"
                    variant="primary"
                    @click="openCreateCustomFileModal">
                    {{ $t('group.add_file') }}
                </b-button>
            </template>
            <template v-slot:cell(actions)="row">
                <div class="row-actions actions">
                    <b-button
                        class="btn-edit btn-edit-custom-editor-file btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="editName(row.item)">
                    </b-button>
                    <b-button
                        class="btn-file-alt btn-sm btn-primary"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        @click="openEditor(row.item)"
                        target="_blank"
                        :title="$t('group.settings.set_up_text')">
                    </b-button>
                    <b-button
                        class="btn-upload remove-icon-margin"
                        variant="primary-icon-only"
                        @click="openUploadFileModal(row.item.id)">
                    </b-button>
                    <b-button
                        class="btn-remove remove-icon-margin"
                        variant="danger-icon-only"
                        @click="remove(row.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-group-show-files-list"
            v-else>
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                @click="openCreateCustomFileModal"
                :title="$t('group.add_file')"></div>
            <div class="alert-notice">{{ $t('group.add_extra_work_file') }}</div>
        </div>
        <design-2021-create-group-custom-editor-file-modal-component
            ref="create-editor-file-modal"
            @GroupCustomEditorFileCreated="groupCustomEditorFileCreate($event)"
            :group-in="groupIn"></design-2021-create-group-custom-editor-file-modal-component>

        <design-2021-edit-name-group-custom-editor-file-modal-component
            ref="edit-name-editor-file-modal"
            @GroupCustomEditorFileUpdated="groupCustomEditorFileUpdated($event)"
            :group-in="groupIn"></design-2021-edit-name-group-custom-editor-file-modal-component>

        <design-2021-group-show-upload-custom-editor-file-modal-component
            ref="upload-file"
            :id="groupIn.id"></design-2021-group-show-upload-custom-editor-file-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-custom-editor-files-component',
    props: {
        groupIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            files: this.groupIn.group_custom_editor_files,
            fileFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        editName(groupEditorFile) {
            this.$refs['edit-name-editor-file-modal'].show(groupEditorFile);
        },

        openCreateCustomFileModal() {
            this.$refs['create-editor-file-modal'].show();
        },

        openUploadFileModal(groupCustomEditorFileId) {
            this.$refs['upload-file'].show(groupCustomEditorFileId);
        },

        groupCustomEditorFileCreate(groupCustomEditorFile) {
            this.files.push(groupCustomEditorFile);
            this.alert.success();
        },

        groupCustomEditorFileUpdated(groupCustomEditorFile) {
            this.files = this.files.map((file) => {
                if (file.id === groupCustomEditorFile.id) {
                    return groupCustomEditorFile;
                }
                return file;
            });
            this.alert.success();
        },

        openEditor(groupCustomEditorFile) {
            window.location.href = this.routes.groupCustomEditorFileInEditor(this.groupIn.id, groupCustomEditorFile.id);
        },

        remove(id) {
            this.alert
                .confirm('Bestand Verwijderen', 'Weet je zeker dat je dit bestand wilt verwijderen?')
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.deleteGroupCustomEditorFile(this.groupIn.id, id)).then(
                            (response) => {
                                this.files = this.files.filter((item) => item.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        editFile(fileRow) {
            const selectedFile = this.files.filter((file) => file.id === fileRow.id);
            if (selectedFile) {
                this.$refs.showEditFileModal.show(fileRow);
            }
        },

        updateFile(updatedFile) {
            this.alert
                .confirm(
                    this.$t('group.update_file_confirmation_title'),
                    this.$t('group.update_file_confirmation_body'),
                    this.$t('common.yes_update'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.post(this.routes.groupFileEdit(this.groupIn.id, updatedFile.id), updatedFile).then(
                        (response) => {
                            this.alert.success();
                            this.files = this.files.map((file) => {
                                if (file.id === updatedFile.id) {
                                    file.name = updatedFile.name;
                                    file.description = updatedFile.description;
                                    file.visibility = updatedFile.visibility;
                                }

                                return file;
                            });
                        },

                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    button {
        &:before {
            margin: 0;
        }
    }
}

.file-actions {
    display: flex;
    align-items: center;

    .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }

    .btn-file-download:before {
        margin-right: 0;
    }
}

::v-deep .files-table {
    .apprentice-table-header {
        .apprentice-data-table-actions {
            margin-top: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.empty-group-show-files-list {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.visibility-status {
    font-size: 1.3125rem;
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    ::v-deep .files-table {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters,
            .apprentice-data-table-actions {
                flex: 0 0 auto;
            }

            .apprentice-data-table-actions {
                margin-top: 0;
            }
        }
    }
}
</style>
